import React, { PropsWithChildren } from "react";
import { Tooltip } from "react-leaflet";
import { TooltipName } from "../../../shared/TooltipName/TooltipName";

import { ContrastName } from "../../../shared/ContrastName/ContrastName";
import { trimText } from "../../../../lib/helpers/trimText";

export const ShapeTooltip = ({
  name,
  className,
  scaleFactor,
  labelAlignment = "center",
  hasContrastTooltips = false,
}: PropsWithChildren<{
  name: string;
  className?: string;
  scaleFactor?: number;
  labelAlignment?: string;
  hasContrastTooltips?: boolean;
}>) => {
  return (
    <Tooltip
      className={`room-permanent-tooltip layer-bookings-tooltip ${className} ${
        labelAlignment === "center-rotated" ? "rotated" : ""
      }`}
      direction="center"
      offset={[0, 0]}
      opacity={1}
      permanent
    >
      {hasContrastTooltips ? (
        <ContrastName
          name={trimText(name, 18)}
          className={className}
          scaleFactor={scaleFactor || 1}
        />
      ) : (
        <TooltipName
          name={name}
          className={className}
          scaleFactor={scaleFactor}
        />
      )}
    </Tooltip>
  );
};
